<template>
    <v-dialog :value="dialog" fullscreen persistent hide-overlay transition="dialog-bottom-transition">
        <confirmOrderPosition></confirmOrderPosition>
    </v-dialog>
</template>

<script>
    import confirmOrderPosition from './ConfirmOrderPosition.vue'
    
    import {
        PurchaseOrderPosition
    } from '../../../store/namespace-helper'

    export default {
      name: 'ConfirmOrderPositionDialog',
      components: {
        confirmOrderPosition
      },
      data () {
        return {}
      },
      methods: {},
      computed: {
        dialog () {
          return this.$store.getters[PurchaseOrderPosition.getters.getOpenDialogState]
        }
      },
      beforeDestroy () {

      }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/PurchaseOrders/OrderPositions/ConfirmOrderPositionDialog.vue